<template>
    <el-dialog :title="$t('Approve.ApproveStep')" :visible.sync="shows" width="680px" height="500px" append-to-body
        @close="close">
        <div class="_steps_box">
            <div class="_steps_item" v-for="(item, index) in ApproveList" :key="index">
                <div class="_steps_item_top">
                    <img src="@/assets/img/user.png" alt="">
                    <span>{{ $t('Approve.Approver') }}</span>
                    <font>（{{ item.ApprovalMethod == 1 ? $t('Approve.countersign') : $t('Approve.orsign') }}）</font>
                </div>
                <div class="_steps_item_bottom" :style="index == ApproveList.length - 1 ? 'border: 0;' : ''">
                    <div class="_dashed_btn" v-if="item.Approver == 4">
                        <el-button icon="el-icon-edit" size="small" class="_dashed" @click.native="update(item, index)">{{
                            item.showlist.length > 0 ? $t('Approve.UpdateApprover') : $t('Approve.AddApprover')
                        }}</el-button>
                    </div>
                    <div class="_steps_item_bottom_item" v-for="(itm, idx) in item.showlist" :key="idx">
                        <img src="@/assets/img/user.png" alt="">
                        <span>{{ itm.UserName }}</span>
                        <i v-if="item.Approver == 4" class="el-icon-error" @click="delitem(index, idx)"></i>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">{{ $t('AssetListAdd.quit') }}</el-button>
            <el-button type="primary" @click="submit">{{ $t('AssetListAdd.query') }}</el-button>
        </div>
        <ApproveUser v-if="UserShow" :show="UserShow" :list="UserList" :checklist="checklist" @close="UserShow = false"
            @submit="setUser">
        </ApproveUser>
    </el-dialog>
</template>
<script>
import { msgTips } from '@/api/user';
import ApproveUser from './ApproveUser.vue';
export default {
    components: { ApproveUser },
    props: {
        show: {
            type: Boolean
        },
        ApprovalList: {
            type: Array
        }
    },
    data() {
        return {
            shows: false,
            ApproveList: [],
            ApproveKeys: [],
            UserList: [],
            checklist: [],
            UserShow: false,
            index: 0
        }
    },
    mounted() {
        if (this.ApprovalList.length > 0) {
            this.ApproveList = this.ApprovalList;
            this.ApproveKeys = this.ApproveList.map(() => {
                return []
            })
        }
        this.shows = this.show;
    },
    methods: {
        update(e, i) {
            this.UserList = e.list;
            this.checklist = e.showlist;
            this.index = i;
            this.UserShow = true;
        },
        delitem(e, i) {
            this.ApproveList[e].showlist.splice(i, 1);
        },
        close() {
            this.$emit('close');
        },
        setUser(e) {
            this.ApproveList[this.index].showlist = e;
            this.UserShow = false;
        },
        submit() {
            let list = [];
            for (let item of this.ApproveList) {
                if (item.Approver == 4) {
                    if (item.showlist.length == 0) {
                        msgTips('有未选择审批人的审批步骤');
                        return
                    }
                    let str = item.showlist.map(val => {
                        return val.UserID;
                    }).join(',');
                    list.push(str)
                }
            }
            this.$emit('submit', list)
        }
    }
}
</script>

<style lang="scss" scoped>
._steps_box {
    width: 100%;
    position: relative;
    overflow-y: auto;

    ._steps_item {
        width: 100%;

        ._steps_item_top {
            height: 30px;
            margin: 5px 0;
            display: flex;
            align-items: center;

            img {
                width: 30px;
                height: 30px;
                border-radius: 50%;
            }

            span {
                font-size: 20px;
                margin-left: 10px;
            }

            font {
                font-size: 16px;
                color: gray;
            }
        }

        ._steps_item_bottom {
            // width: ca;
            padding: 20px;
            position: relative;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            border-left: 1.5px solid #efefef;
            margin-left: 15px;

            ._steps_item_bottom_item {
                display: inline-flex;
                vertical-align: middle;
                align-items: center;
                font-size: 14px;
                height: 33px;
                padding: 8px;
                border-radius: 4px;
                background-color: #f7fafa;
                margin: 5px;
                cursor: pointer;
                line-height: 1;

                img {
                    width: 18px;
                    height: 18px;
                    border-radius: 50%;
                }

                span {
                    margin: 0 10px;
                }

                font {
                    color: #979797;
                    margin: 0 10px;
                }

                &:hover {
                    background-color: #eee;
                }
            }
        }
    }

    ._dashed_btn {
        height: 33px;
        margin: 5px;
        display: inline-block;
    }

    ._dashed {
        border: 1px dashed #dcdfe6;
        /* 虚线颜色和粗细 */
        background-color: transparent;
        /* 背景透明 */
        position: relative;

        &::after {
            content: '*';
            position: absolute;
            top: -5px;
            right: -3px;
            color: red;
            font-size: 16px;
        }
    }
}
</style>